(function (angular) {
    'use strict';

    angular.module('whatsApp')
        .controller('whatsAppCloudConfigurationController',
        ['$scope', '$stateParams', 'whatsAppConfig', '$uibModalInstance',
            function ($scope, $stateParams, whatsAppConfig, $uibModalInstance) {
                $scope.whatsAppConfig = whatsAppConfig;
                $scope.integrationSuccessful = whatsAppConfig.configurationStatus === "Success";
                $scope.integrationInProgress = whatsAppConfig.configurationStatus === "InProgress" || !whatsAppConfig.configurationStatus;
        
                $scope.close = function(){
                    $uibModalInstance.dismiss('cancel');
                };
        }]);


})(window.angular);